__webpack_require__.p = "https://biesse-vietnam.netlify.app/";